import { forwardRef } from 'react';
import { ChartHR } from '@/entities/heart-rate';
import useHrChart from './useHrChart';

export type HrChartHandle = {
  handleClickArrowButton: (isNext: boolean) => void;
};

export type HrChartProps = {
  timezoneOffset: number;
  ecgDataMap: any;
  studyId: string;
  profileId: string;
};

/**
 * Displays the heart-rate chart above the artifact-areas strip list. Pulls chart data, the tab key and the strip-selection callback from useHrChart, then renders the still-untyped ChartHR through an any cast with a fixed container id and minimum width.
 *
 * @param props - Chart props including the timezone offset.
 * @param ref - Forwarded handle exposing the chart's imperative API.
 * @returns The rendered heart-rate chart for the artifact areas.
 */
const HrChart = forwardRef<HrChartHandle, HrChartProps>(
  ({ timezoneOffset, ecgDataMap, studyId, profileId }, ref) => {
    const { keyRecoil, dataChart, updatedSelectedStrip, chartHrRef } = useHrChart(
      { timezoneOffset, ecgDataMap, studyId, profileId },
      ref,
    );

    // ChartHR is still plain JS (forwardRef without a props generic, Task 10) - TS infers no props at all.
    const ChartHRAny = ChartHR as any;
    return (
      <ChartHRAny
        ref={chartHrRef}
        idHtmlChart="artifact-events-hr-chart-container"
        keyRecoil={keyRecoil}
        dataChart={dataChart}
        updatedSelectedStrip={updatedSelectedStrip}
        timezoneOffset={timezoneOffset}
        minWidth={1395}
      />
    );
  },
);

export default HrChart;
